module.exports = __webpack_public_path__ + "fonts/41b973f.otf";